// src/components/TableFinancieras.jsx
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import {
  getFinancieras,
  deleteFinanciera,
  getFinancieraById,
} from "../helpers/rutaFinancieras";
import ModalFormFinanciera from "./ModalFormFinanciera";
import "../css/tableclientes.css";

/* ---------------- ANCHOS DE COLUMNAS ---------------- */
/* Tocá estos valores para ajustar el ancho de cada campo */
const COLS = {
  acciones: 95,
  codigo: 60,
  financiera: 260,
  razonsocial: 300,
  cuit: 140,
  telefono: 150,
  email: 260,
  contacto: 200,
};

const TABLE_WIDTH = Object.values(COLS).reduce((acc, n) => acc + n, 0);

/* ---------------- HELPERS ---------------- */

const clean = (v) => String(v ?? "").trim();

const getFinancieraFromResponse = (resp) => {
  if (!resp) return null;

  // Si ya viene el objeto financiera directo desde el helper
  if (resp?._id || resp?.id) return resp;

  // Si viene envuelto desde backend
  if (resp?.financiera && typeof resp.financiera === "object") {
    return resp.financiera;
  }

  if (resp?.data?.financiera && typeof resp.data.financiera === "object") {
    return resp.data.financiera;
  }

  if (resp?.ok && resp?.data && typeof resp.data === "object") {
    return resp.data;
  }

  return null;
};

const tdText = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const thCenter = {
  textAlign: "center",
  verticalAlign: "middle",
};

const tdCenter = {
  textAlign: "center",
  verticalAlign: "middle",
};

/* ---------------- COMPONENTE ---------------- */

const TableFinancieras = () => {
  const [state, setState] = useState({
    financieras: [],
    loading: true,
    error: "",
  });

  const [financiera, setFinanciera] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaFinancieras();
  }, []);

  const consultaFinancieras = async () => {
    try {
      setState((prev) => ({
        ...prev,
        loading: true,
        error: "",
      }));

      const datos = await getFinancieras({
        page: 1,
        limit: 100,
      });

      const lista = Array.isArray(datos?.financieras)
        ? datos.financieras
        : Array.isArray(datos?.data?.financieras)
        ? datos.data.financieras
        : Array.isArray(datos)
        ? datos
        : [];

      setState({
        financieras: lista,
        loading: false,
        error: "",
      });
    } catch (e) {
      console.error("❌ Error getFinancieras:", e);

      setState({
        financieras: [],
        loading: false,
        error: e?.message || "Error al cargar financieras",
      });
    }
  };

  const handleClose = () => {
    setShow(false);
    consultaFinancieras();
  };

    const modificaFinanciera = async (id) => {
    if (!id) return alert("No se encontró el ID de la financiera.");

    try {
        const resp = await getFinancieraById(id);
        const fin = getFinancieraFromResponse(resp);

        console.log("🟡 RESP getFinancieraById:", resp);
        console.log("🟢 FINANCIERA PARA MODAL:", fin);

        if (!fin?._id && !fin?.id) {
        console.error("❌ Respuesta inesperada getFinancieraById:", resp);
        return alert("No se pudo obtener la financiera para modificar.");
        }

        setFinanciera(fin);
        setShow(true);
    } catch (err) {
        console.error("❌ Error getFinancieraById:", err);
        alert("No se pudo obtener la financiera para modificar.");
    }
    };

  const eliminarFinanciera = async (id) => {
    if (!id) return alert("No se encontró el ID de la financiera.");

    if (!window.confirm("¿Está seguro que desea borrar la financiera?")) return;

    try {
      await deleteFinanciera(id);
      consultaFinancieras();
    } catch (err) {
      console.error("❌ Error deleteFinanciera:", err);
      alert("No se pudo borrar la financiera.");
    }
  };

  if (state.loading) {
    return <div className="p-3">Cargando financieras…</div>;
  }

  if (state.error) {
    return <div className="p-3 text-danger">{state.error}</div>;
  }

  const rows = state.financieras.filter((f) => f?.activo ?? true);

  return (
    <div className="table-container">
      <div className="col-12 mt-4" />

      <div
        style={{
          width: "100%",
          overflowX: "auto",
          paddingBottom: 8,
        }}
      >
        <Table
          striped
          bordered
          hover
          size="sm"
          style={{
            tableLayout: "fixed",
            width: TABLE_WIDTH,
            minWidth: TABLE_WIDTH,
            fontSize: "0.82rem",
            marginBottom: 0,
          }}
        >
          <colgroup>
            <col style={{ width: COLS.acciones }} />
            <col style={{ width: COLS.codigo }} />
            <col style={{ width: COLS.financiera }} />
            <col style={{ width: COLS.razonsocial }} />
            <col style={{ width: COLS.cuit }} />
            <col style={{ width: COLS.telefono }} />
            <col style={{ width: COLS.email }} />
            <col style={{ width: COLS.contacto }} />
          </colgroup>

          <thead>
            <tr>
              <th style={thCenter}>Acciones</th>
              <th style={thCenter}>Código</th>
              <th style={thCenter}>Financiera</th>
              <th style={thCenter}>Razón Social</th>
              <th style={thCenter}>CUIT</th>
              <th style={thCenter}>Teléfono</th>
              <th style={thCenter}>Email</th>
              <th style={thCenter}>Contacto</th>
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={8} className="text-center">
                  No hay financieras.
                </td>
              </tr>
            ) : (
              rows.map((f) => {
                const id = f._id || f.id;

                return (
                  <tr key={id || f.codfinanciera}>
                    <td style={tdCenter}>
                      <div
                        style={{
                          display: "flex",
                          gap: 6,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() => modificaFinanciera(id)}
                          title="Modificar"
                          style={{
                            width: 28,
                            height: 28,
                            padding: 0,
                          }}
                        >
                          <i
                            className="fa fa-pencil-square-o"
                            aria-hidden="true"
                          />
                        </button>

                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => eliminarFinanciera(id)}
                          title="Eliminar"
                          style={{
                            width: 28,
                            height: 28,
                            padding: 0,
                          }}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </div>
                    </td>

                    <td style={tdCenter}>{f.codfinanciera || "-"}</td>

                    <td
                      style={{
                        textAlign: "left",
                        verticalAlign: "middle",
                        ...tdText,
                      }}
                      title={clean(f.financiera)}
                    >
                      {clean(f.financiera) || "-"}
                    </td>

                    <td
                      style={{
                        textAlign: "left",
                        verticalAlign: "middle",
                        ...tdText,
                      }}
                      title={clean(f.razonsocial)}
                    >
                      {clean(f.razonsocial) || "-"}
                    </td>

                    <td style={{ ...tdCenter, ...tdText }} title={f.cuit || ""}>
                      {f.cuit || "-"}
                    </td>

                    <td
                      style={{ ...tdCenter, ...tdText }}
                      title={f.telefono1 || ""}
                    >
                      {f.telefono1 || "-"}
                    </td>

                    <td
                      style={{
                        textAlign: "left",
                        verticalAlign: "middle",
                        ...tdText,
                      }}
                      title={f.email || ""}
                    >
                      {f.email || "-"}
                    </td>

                    <td
                      style={{
                        textAlign: "left",
                        verticalAlign: "middle",
                        ...tdText,
                      }}
                      title={f.contacto || ""}
                    >
                      {f.contacto || "-"}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>

      <ModalFormFinanciera
        show={show}
        handleClose={handleClose}
        financiera={financiera}
        onSaved={consultaFinancieras}
      />

      
    </div>
  );
};

export default TableFinancieras;